"use strict";
var InsightsPopoverService = (function () {
    /* @ngInject */
    function InsightsPopoverService(cookieMonsterService, INSIGHTS_POPOVER) {
        this.cookieMonsterService = cookieMonsterService;
        this.INSIGHTS_POPOVER = INSIGHTS_POPOVER;
    }
    /**
     * Determines if the Analytics popover should be displayed or not.
     *
     * - The Analytics tool-tip will be visible to all users;
     * - User can disable it;
     * - If user disables and hasn't logged into Naviance Insights in 2 weeks then show the Analytics tool-tip again.
     *
     * @param accessLevel string 'school' or 'district'
     * @return bool
     */
    InsightsPopoverService.prototype.isAnalyticsPopoverDisplayed = function (accessLevel) {
        var _this = this;
        return this.getAnalyticsCookie(accessLevel).then(function (lastDisplayTime) {
            lastDisplayTime = parseInt(lastDisplayTime + "", 10) || 0;
            if (!lastDisplayTime) {
                return true;
            }
            var diff = _this.time - lastDisplayTime;
            if (diff > _this.INSIGHTS_POPOVER.analyticsHidePeriod) {
                _this.deleteAnalyticsCookie(accessLevel);
                _this.deleteInsightsCookie(accessLevel);
                return true;
            }
            return false;
        });
    };
    /**
     * Determines if the Naviance Insights popover should be displayed or not.
     *
     * - Show tool-tip when the user hovers on Naviance Insights;
     * - The user has no ability to disable this tool-tip;
     * - Don't show this tool-tip any more if the user has accessed Naviance Insights 4 or more times
     *    within the last 30 days since disabling the Analytics tool-tip.
     *
     * @param accessLevel string 'school' or 'district'
     * @return bool
     */
    InsightsPopoverService.prototype.isInsightsPopoverDisplayed = function (accessLevel) {
        var _this = this;
        return this.isAnalyticsPopoverDisplayed(accessLevel).then(function (isAnalyticsPopoverDisplayed) {
            if (isAnalyticsPopoverDisplayed) {
                return true;
            }
            return _this.getInsightsAccessCount(accessLevel).then(function (count) {
                return count < _this.INSIGHTS_POPOVER.insightsHideAccessCount;
            });
        });
    };
    InsightsPopoverService.prototype.refreshAnalyticsPopoverDisplay = function (accessLevel) {
        return this.setCookie(this.INSIGHTS_POPOVER.analyticsCookieName, this.time, accessLevel);
    };
    InsightsPopoverService.prototype.getInsightsAccessCount = function (accessLevel) {
        return this.getInsightsRequests(accessLevel).then(function (requests) {
            var count = 0;
            Object.keys(requests).forEach(function (date) {
                count += requests[date];
            });
            return count;
        });
    };
    InsightsPopoverService.prototype.getInsightsRequests = function (accessLevel) {
        var dateFrom = this.today - this.INSIGHTS_POPOVER.insightsHideAccessInterval;
        return this.getInsightsCookie(accessLevel).then(function (requests) {
            requests = requests || {};
            Object.keys(requests).forEach(function (date) {
                if (Math.round(new Date(date).getTime() / 1000) < dateFrom) {
                    delete requests[date];
                }
            });
            return requests;
        });
    };
    InsightsPopoverService.prototype.getAnalyticsCookie = function (accessLevel) {
        return this.getCookie(this.INSIGHTS_POPOVER.analyticsCookieName, accessLevel);
    };
    InsightsPopoverService.prototype.deleteAnalyticsCookie = function (accessLevel) {
        return this.deleteCookie(this.INSIGHTS_POPOVER.analyticsCookieName, accessLevel);
    };
    InsightsPopoverService.prototype.getInsightsCookie = function (accessLevel) {
        return this.getCookie(this.INSIGHTS_POPOVER.insightsCookieName, accessLevel);
    };
    InsightsPopoverService.prototype.deleteInsightsCookie = function (accessLevel) {
        return this.deleteCookie(this.INSIGHTS_POPOVER.insightsCookieName, accessLevel);
    };
    InsightsPopoverService.prototype.getCookie = function (key, accessLevel) {
        return this.cookieMonsterService.get(this.getCookieKey(key, accessLevel));
    };
    InsightsPopoverService.prototype.setCookie = function (key, value, accessLevel) {
        return this.cookieMonsterService.set(this.getCookieKey(key, accessLevel), value);
    };
    InsightsPopoverService.prototype.deleteCookie = function (key, accessLevel) {
        return this.cookieMonsterService.delete(this.getCookieKey(key, accessLevel));
    };
    InsightsPopoverService.prototype.getCookieKey = function (key, accessLevel) {
        return key + ":" + accessLevel;
    };
    Object.defineProperty(InsightsPopoverService.prototype, "time", {
        get: function () {
            return Math.round((new Date()).getTime() / 1000);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InsightsPopoverService.prototype, "today", {
        get: function () {
            var date = new Date();
            date.setUTCHours(0, 0, 0, 0);
            return Math.round(date.getTime() / 1000);
        },
        enumerable: true,
        configurable: true
    });
    return InsightsPopoverService;
}());
exports.InsightsPopoverService = InsightsPopoverService;



/** WEBPACK FOOTER **
 ** ./app/insights/insights-popover.service.ts
 **/